import { render, staticRenderFns } from "./SoftbookLangDropdown.vue?vue&type=template&id=478c4b42&"
import script from "./SoftbookLangDropdown.ts?vue&type=script&lang=ts&"
export * from "./SoftbookLangDropdown.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SoftbookLangDropdown.vue"
export default component.exports